var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import moment from "moment";
import { Navigate as NavigateAction, } from "react-big-calendar";
import axios from "axios";
import { toast } from "react-toastify";
import { reloadTimeLogs } from "../../../store/slices/reloadSlice";
import { useDispatch, useSelector } from "react-redux";
import { Fab } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import ArrowForwardOutlinedIcon from '@mui/icons-material/ArrowForwardOutlined';
var CustomDayView = function (_a) {
    var date = _a.date, events = _a.events, onNavigate = _a.onNavigate, onDeleteEvent = _a.onDeleteEvent;
    var dispatch = useDispatch();
    var calendarEvent = useSelector(function (state) { return state.site.calendarEvent; });
    var deductions = useSelector(function (state) { return state.site.deductions; });
    console.log('deductions', deductions);
    var _b = React.useState(new Set()), selected = _b[0], setSelected = _b[1];
    if (!date) {
        return _jsx("div", { children: "No date provided" });
    }
    var yesterdayEvents = calendarEvent ? calendarEvent.filter(function (e) {
        var loopDate = moment(e.date);
        return moment(date).subtract(1, "day").isSame(loopDate, "day");
    }) : [];
    var todaysEvents = events ? events.filter(function (e) {
        return moment(e.start).isSame(date, "day");
    }) : [];
    var tomorrowEvents = calendarEvent ? calendarEvent.filter(function (e) {
        var loopDate = moment(e.date);
        return moment(date).add(1, "day").isSame(loopDate, "day");
    }) : [];
    var sorted = __spreadArray([], todaysEvents, true).sort(function (a, b) { return new Date(a.start).getTime() - new Date(b.start).getTime(); });
    var todaysGroups = new Set(sorted.map(function (e) { return e.group; }));
    // First and last event of the current day
    var firstHour = sorted[0];
    var lastHour = sorted[sorted.length - 1];
    // Determine if there are events on the previous or next day
    var previousDayLastHour = moment(date).subtract(1, "day").endOf('day').subtract(1, 'hours');
    var nextDayFirstHour = moment(date).add(1, "day").startOf('day');
    var isLoggedIn = useSelector(function (state) { return state.user.isLoggedIn; });
    var isPrevious = yesterdayEvents.length > 0;
    var isNext = false;
    if (tomorrowEvents.length > 0 && lastHour && lastHour.group)
        isNext = (todaysGroups.has(lastHour.group) /* && lastHour.start.getTime() == nextDayFirstHour.toDate().getTime()*/);
    // debugger;
    var handleSelectevent = function (eventId) {
        if (!isLoggedIn)
            return;
        var newSelected = new Set(selected);
        if (newSelected.has(eventId)) {
            newSelected.delete(eventId);
        }
        else {
            newSelected.add(eventId);
        }
        setSelected(newSelected);
    };
    var deleteSelected = function () { return __awaiter(void 0, void 0, void 0, function () {
        var isConfirmed, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    isConfirmed = confirm('Are you sure you want to deelete the selected time logs?');
                    if (!isConfirmed) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, axios.delete("/time_logs_bulk_delete", {
                            data: { ids: Array.from(selected) },
                            headers: {
                                "Content-Type": "application/json",
                            },
                        })];
                case 2:
                    response = _a.sent();
                    console.log("response", response);
                    if (response.status === 200) {
                        toast.success(response.data.message);
                        dispatch(reloadTimeLogs());
                        // Optionally, trigger a refresh or update the UI
                    }
                    else if (response.status === 401) {
                        toast.error(response.data.message);
                    }
                    else {
                        toast.error(response.data.message);
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    toast.error("An error occurred while deleting the time log.");
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs("div", { className: "day-view-container", children: [_jsx("h2", { className: "text-xl text-[#0A2342] mb-4 mt-4", children: moment(date).format("dddd, MMMM D, YYYY") }), sorted.length === 0 ? (_jsx("p", { className: "text-gray-500 italic", children: "No events for day." })) : (sorted.map(function (event) { return (_jsxs("div", { className: "mb-3 flex flex-row items-center justify-between bg-[#e3fdfc] rounded-lg ".concat(selected.has(event.id) ? "border-[1px] border-[#00A190]" : ""), onClick: function () { return handleSelectevent(event.id); }, children: [_jsxs("div", { className: "w-full flex flex-col items-start justify-between border rounded-l-lg p-3 ".concat(selected.has(event.id) ? "border-[0px]" : "border-white bg-white"), children: [_jsx("span", { className: "text-[#008375] rounded-lg bg-[#cce6e3] px-3 py-1.5 text-center mb-1", children: event.position_relation ? event.position_relation.position : 'No Position' }), _jsx("span", { className: "text-[#0A2342] font-medium my-1 text-lg", children: event.header_name }), _jsxs("div", { className: "flex justify-space gap-2", children: [_jsx("span", { className: "text-[#0A2342] font-medium my-1 text-lg", children: event.ship_name }), _jsx("span", { className: "text-[#76808B] font-small my-1 text-lg", children: event.vessel ? event.vessel.name : 'No Vessel' })] }), _jsxs("div", { className: "flex items-center gap-2 mb-1", children: [_jsx("div", { className: "text-[#0A2342] rounded-lg bg-[#cce6e3]  px-3 py-1.5", children: moment(event.start).format("h:mm A") }), _jsx(ArrowForwardOutlinedIcon, { style: { fontSize: 24, fontWeight: 'bold', color: '#00A190' } }), _jsx("div", { className: "text-[#0A2342] rounded-lg bg-[#ced3d9]  px-3 py-1.5", children: moment(event.end).format("h:mm A") })] }), event.is_break === 1 && _jsxs("div", { className: "mt-1 inline-flex items-center bg-green-50 border-2 border-green-500 text-green-700 px-3 py-1 rounded-lg shadow-sm", children: [_jsx(EmojiEventsIcon, { className: "mr-2 text-green-600" }), _jsx("span", { className: "font-semibold text-sm", children: "Skipped Meal" })] })] }), _jsx("div", { className: "flex flex-col items-end justify-center mx-4 h-full", children: _jsxs("span", { className: "text-[#00A190] font-semibold", children: ["$", event.content] }) })] }, event.start.toString())); })), _jsx("div", { className: "rbc-toolbar", children: _jsxs("span", { className: "rbc-btn-group", children: [isPrevious && _jsx("button", { type: "button", onClick: function () { return onNavigate(NavigateAction.PREVIOUS); }, children: "Back" }), isNext && _jsx("button", { type: "button", onClick: function () { return onNavigate(NavigateAction.NEXT); }, children: "Next" })] }) }), selected.size > 0 && (_jsx("div", { className: "fixed top-[13rem] right-6 z-10 flex flex-col gap-2 w-[48px]  items-center justify-center", children: _jsx(Fab, { color: "primary", size: "medium", "aria-label": "delete", onClick: deleteSelected, children: _jsx(DeleteIcon, {}) }) }))] }));
};
// ... (Static navigate and title methods remain the same) ...
CustomDayView.navigate = function (date, action, _a) {
    var localizer = _a.localizer;
    switch (action) {
        case NavigateAction.PREVIOUS:
            return localizer.add(date, -1, "day");
        case NavigateAction.NEXT:
            return localizer.add(date, 1, "day");
        default:
            return date;
    }
};
CustomDayView.title = function (date, _a) {
    var localizer = _a.localizer;
    return localizer.format(date, "dayHeaderFormat");
};
export default CustomDayView;
